import { render } from "./PanelAdminBulletin.vue?vue&type=template&id=7692cfb9&scoped=true&ts=true"
import script from "./PanelAdminBulletin.vue?vue&type=script&lang=ts"
export * from "./PanelAdminBulletin.vue?vue&type=script&lang=ts"

import "./PanelAdminBulletin.vue?vue&type=style&index=0&id=7692cfb9&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7692cfb9"]])

export default __exports__